<div class="dashboard-container">
    <!-- Fixed Logo (always visible) -->
    <div class="fixed-logo" [class.sidebar-expanded]="!sidebarCollapsed">
        <!-- Hamburger Menu Toggle -->
        <div class="hamburger-toggle" (click)="toggleSidebar()">
            <i class="bi bi-list"></i>
        </div>
        
        <!-- Logo -->
        <div class="logo">
            <img 
                src="assets/images/Lumen-main_full-KO.svg" 
                alt="Lumen Logo"
                height="45"
            >
        </div>
    </div>

    <!-- Sidebar -->
    <nav class="sidebar" [class.collapsed]="sidebarCollapsed">
        <!-- Navigation Items (no logo here anymore) -->
        <div class="sidebar-items">
            <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidebar-item">
                <i class="bi bi-house-door"></i>
                <span class="sidebar-item-text" *ngIf="!sidebarCollapsed">Home</span>
            </a>
            
            <!-- Author Analytics with submenu -->
            <div class="sidebar-item-group">
                <a 
                    class="sidebar-item" 
                    [class.active]="isAuthorMenuActive()" 
                    (click)="toggleAuthorSubmenu()"
                >
                    <i class="bi bi-feather"></i>
                    <span class="sidebar-item-text" *ngIf="!sidebarCollapsed">Author Analytics</span>
                    <i *ngIf="!sidebarCollapsed" class="bi submenu-indicator" 
                       [ngClass]="authorSubmenuOpen ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                </a>
                
                <!-- Submenu items -->
                <div class="submenu" *ngIf="authorSubmenuOpen && !sidebarCollapsed">
                    <a routerLink="/author-analytics" 
                       [queryParams]="{view: 'pool'}"
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-people"></i>
                        <span>Authors</span>
                    </a>
                    <a routerLink="/author-analytics" 
                       [queryParams]="{view: 'submissions'}"
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-file-earmark-text"></i>
                        <span>Submissions</span>
                    </a>
                </div>
            </div>

            <!-- Campaign Analytics with submenu -->
            <div class="sidebar-item-group">
                <a 
                    class="sidebar-item" 
                    [class.active]="isCampaignMenuActive()" 
                    (click)="toggleCampaignSubmenu()"
                >
                    <i class="bi bi-megaphone"></i>
                    <span class="sidebar-item-text" *ngIf="!sidebarCollapsed">Campaign Analytics</span>
                    <i *ngIf="!sidebarCollapsed" class="bi submenu-indicator" 
                       [ngClass]="campaignSubmenuOpen ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                </a>
                
                <!-- Submenu items -->
                <div class="submenu" *ngIf="campaignSubmenuOpen && !sidebarCollapsed">
                    <a routerLink="/campaign-performance" 
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-graph-up"></i>
                        <span>Dot Digital</span>
                    </a>
                    <a routerLink="/hum-campaigns" 
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-bullseye"></i>
                        <span>HUM</span>
                    </a>
                    <a routerLink="/aet-funnel" 
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-funnel"></i>
                        <span>AET Funnel</span>
                    </a>
                </div>
            </div>

            <!-- Articles -->
            <!-- <a routerLink="/articles" routerLinkActive="active" class="sidebar-item">
                <i class="bi bi-file-earmark-text"></i>
                <span class="sidebar-item-text">Article Analytics</span>
            </a> -->
            <div class="sidebar-item-group">
                <a 
                    class="sidebar-item" 
                    [class.active]="isArticleMenuActive()" 
                    (click)="toggleArticleSubmenu()"
                >
                    <i class="bi bi-file-earmark-text"></i>
                    <span class="sidebar-item-text" *ngIf="!sidebarCollapsed">Article Analytics</span>
                    <i *ngIf="!sidebarCollapsed" class="bi submenu-indicator" 
                       [ngClass]="articleSubmenuOpen ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                </a>
                
                <!-- Submenu items -->
                <div class="submenu" *ngIf="articleSubmenuOpen && !sidebarCollapsed">
                    <a routerLink="/article-details" 
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-bar-chart-line"></i>
                        <span>Publishing</span>
                    </a>
                    <a routerLink="/article-usage" 
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-book"></i>
                        <span>Usage</span>
                    </a>
                </div>
            </div>

            <!-- Journal Dashboard -->
            <a routerLink="/journal-dashboard" routerLinkActive="active" class="sidebar-item">
              <i class="bi bi-journal-text"></i>
              <span class="sidebar-item-text" *ngIf="!sidebarCollapsed">Journal Dashboard</span>
            </a>

            <!-- Institution Unified (New) -->
            <a routerLink="/institution-unified" routerLinkActive="active" class="sidebar-item">
              <i class="bi bi-building"></i>
              <span class="sidebar-item-text" *ngIf="!sidebarCollapsed">Institutions</span>
            </a>
            <a routerLink="/profile-analytics" routerLinkActive="active" class="sidebar-item">
              <i class="bi bi-person-lines-fill"></i>
              <span class="sidebar-item-text" *ngIf="!sidebarCollapsed">Profile</span>
            </a>

            <!-- Tools with submenu -->
            <div class="sidebar-item-group">
                <a 
                    class="sidebar-item" 
                    [class.active]="isToolsMenuActive()" 
                    (click)="toggleToolsSubmenu()"
                >
                    <i class="bi bi-tools"></i>
                    <span class="sidebar-item-text" *ngIf="!sidebarCollapsed">Tools</span>
                    <i *ngIf="!sidebarCollapsed" class="bi submenu-indicator" 
                       [ngClass]="toolsSubmenuOpen ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                </a>
                
                <!-- Submenu items -->
                <div class="submenu" *ngIf="toolsSubmenuOpen && !sidebarCollapsed">
                    <a routerLink="/sales-lead-lookup" 
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-search"></i>
                        <span>Email Lookup</span>
                    </a>
                    <a routerLink="/author-contact" 
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-person-vcard"></i>
                        <span>Author Contacts - By DOI</span>
                    </a>
                    <a routerLink="/thesaurus-lookup" 
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-book"></i>
                        <span>Thesaurus Child Lookup</span>
                    </a>
                    <a routerLink="/term-count" 
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-journal-text"></i>
                        <span>Thesaurus Terms - By DOI</span>
                    </a>
                    <a routerLink="/lead-evaluation" 
                       routerLinkActive="active" 
                       class="submenu-item">
                        <i class="bi bi-clipboard-check"></i>
                        <span>Lead Evaluation</span>
                    </a>
                </div>
            </div>
        </div>
    </nav>

    <!-- Main Content -->
    <main class="main-content" [class.sidebar-expanded]="!sidebarCollapsed">
        <header class="dashboard-header">
            <div class="header-left">
                <!-- Empty space -->
            </div>
            
            <div class="header-right">
                <!-- Data Refresh Timer -->
                <div class="refresh-timer">
                    <span class="refresh-label">Data last refreshed on: </span>
                    <div *ngIf="isRefreshTimeLoading" class="inline-spinner"></div>
                    <span class="refresh-time" *ngIf="!isRefreshTimeLoading">{{ lastRefreshTime }}</span>
                </div>
                
                <div class="user-menu" (click)="$event.stopPropagation()">
                    <button
                        class="user-menu-trigger"
                        type="button"
                        (click)="toggleUserMenu($event)"
                        [attr.aria-expanded]="userMenuOpen"
                        aria-label="Open user menu"
                    >
                        <div class="user" *ngIf="userAccount">
                            <div class="user-initials">
                                {{ getUserInitials() }}
                            </div>
                            <div class="user-details">
                                <span class="user-name">{{ userAccount.name }}</span>
                                <span class="user-email">{{ userAccount.username }}</span>
                            </div>
                        </div>
                        <div class="user" *ngIf="!userAccount">
                            <i class="bi bi-person-circle avatar"></i>
                            <span class="user-role">Admin</span>
                        </div>
                        <i class="bi" [ngClass]="userMenuOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    </button>

                    <div class="user-dropdown" *ngIf="userMenuOpen" role="menu">
                        <div class="dropdown-header" *ngIf="userAccount">
                            <div class="dropdown-name">{{ userAccount.name }}</div>
                            <div class="dropdown-email">{{ userAccount.username }}</div>
                        </div>

                        <button
                            class="dropdown-item"
                            type="button"
                            (click)="toggleHelpMenu($event)"
                            [attr.aria-expanded]="helpMenuOpen"
                        >
                            <span>Help</span>
                            <i class="bi" [ngClass]="helpMenuOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                        </button>

                        <div class="help-submenu" *ngIf="helpMenuOpen">
                            <a class="dropdown-subitem" [href]="mailtoFeatureRequest" (click)="closeUserMenu()">
                                Request a Feature
                            </a>
                            <a class="dropdown-subitem" [href]="mailtoIssueReport" (click)="closeUserMenu()">
                                Report a Problem
                            </a>
                        </div>

                        <!-- <button class="dropdown-item danger" type="button" (click)="logout(); closeUserMenu()">
                            Logout
                        </button> -->
                    </div>
                </div>
            </div>
        </header>
        
        <div class="content-area">
            <router-outlet></router-outlet>
        </div>
    </main>

    <!-- Query Insights -->
    <!--<app-query-insights (collapsedChange)="onQueryInsightsToggle($event)"></app-query-insights>-->
</div> 